import { createSelector } from 'reselect';

import getElectCertificatesSelector from './getElectCertificatesSelector';

export default createSelector([getElectCertificatesSelector], (certs) => {
  const energyTotal = certs.reduce((total, cert) => {
    return total + (cert.total_energy_kwh || 0);
  }, 0);
  const energyAllocated = certs.reduce((total, cert) => {
    return total + (cert.energy_allocation_for_this_carbon_review_kwh || 0);
  }, 0);

  const energyAssigned = certs.reduce((total, cert) => {
    return total + (cert.total_kwh_used_by_locations || 0);
  }, 0);
  /*
  Allocated means "how much of a certificate does a carbon review have access to for the reporting period",
  and Assigned means "how much of that amount has been portioned out via consumption data"
   */
  return {
    energyTotal,
    energyAllocated,
    energyRemaining: energyAllocated - energyAssigned,
    energyAssigned,
  };
});
/*
energyTotal, energyAllocated, energyRemaining
 */
